import { render, staticRenderFns } from "./talkDetail.vue?vue&type=template&id=4c931271&scoped=true&"
import script from "./talkDetail.vue?vue&type=script&lang=js&"
export * from "./talkDetail.vue?vue&type=script&lang=js&"
import style0 from "./talkDetail.vue?vue&type=style&index=0&id=4c931271&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c931271",
  null
  
)

export default component.exports